(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('CampaignPartAddQuestionController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'surveyCampaignService', 'campaign', 'questionType', 'part'];

    function Controller($scope, $state, topBarService, surveyCampaignService, campaign, questionType, part) {
        $scope.campaignPart  = part;
        $scope.questionType  = questionType;
        $scope.questionToAdd = {
            QuestionTypeID: questionType.QuestionTypeID,
            OrderNumber: null
        };

        // Add Question
        $scope.addQuestion = function () {

            surveyCampaignService
                .createQuestion(campaign.SlugObject, part.CampaignPartID, $scope.questionToAdd)
                .then(function (addedQuestion) {
                    if (questionType.Code === 'CustomMultipleChoice' ||
                        questionType.QuestionTypeCategoryBehaviour === 'QuizWithOneResponse') {
                        $scope.addedQuestion = addedQuestion;
                        $scope.addedQuestion.QuestionChoices = [{}];
                    } else {
                        $scope.goBackToQuestions();
                    }
                });
        };

        // Add Question Choice
        $scope.addQuestionChoice = function (choice) {
            surveyCampaignService
                .createQuestionChoice(campaign.SlugObject, part.CampaignPartID, $scope.addedQuestion.QuestionID, choice)
                .then(function (addedQuestionChoice) {
                    choice.QuestionChoiceID = addedQuestionChoice.QuestionChoiceID;
                    $scope.addedQuestion.QuestionChoices.push({});
                });
        };

        // Remove Question Choice
        $scope.removeQuestionChoice = function (choice) {
            surveyCampaignService
               .deleteQuestionChoice(campaign.SlugObject, part.CampaignPartID, $scope.addedQuestion.QuestionID, choice)
               .then(function () {
                   if ($scope.addedQuestion.QuestionChoices.length === 1) {
                       $scope.addedQuestion.QuestionChoices = [{}];
                   } else {
                       $scope.addedQuestion.QuestionChoices = _.reject($scope.addedQuestion.QuestionChoices, { QuestionChoiceID: choice.QuestionChoiceID });
                   }
               });
        };

        // Is Subtitle Required
        $scope.isSubtitleRequired = function () {
            return $scope.questionType.QuestionTypeCategoryID === 6;
        };

        // Ask for Subtitle
        $scope.askForSubtitle = function () {
            return $scope.questionType.QuestionTypeCategoryID === 5 ||  // Rating, Title
                   $scope.questionType.QuestionTypeCategoryID === 6 ||  // Rating, No Title
                   $scope.questionType.QuestionTypeCategoryID === 9 ||  // Economics Expertise, Title
                   $scope.questionType.QuestionTypeCategoryID === 10 || // Economics Expertise, No Title
                   $scope.questionType.QuestionTypeCategoryID === 11 || // Ranking, Title
                   $scope.questionType.QuestionTypeCategoryID === 12;   // Ranking, No Title
        };

        // Ask for Postmortem
        $scope.askForPostmortem = function () {
            return $scope.questionType.QuestionTypeCategoryID === 8;
        };

        // Cancel Question Creation
        $scope.cancelQuestionCreation = function () {
            if ($scope.addedQuestion) {
                surveyCampaignService
                    .deleteQuestion(campaign.SlugObject, part.CampaignPartID, $scope.addedQuestion)
                    .then(function () {
                        $scope.goBackToQuestions();
                    });
            } else {
                $scope.goBackToQuestions();
            }
        };

        // Go Back To Questions
        $scope.goBackToQuestions = function () {
            $state.go('survey.campaign.slug.part.builder', {}, { reload: true });
        };

        topBarService.setTitleAndIcon(campaign.TitleEN, 'fa fa-bullhorn', 'Questionnaire Builder', 'fa fa-list-alt');
    }
})();